import { StockInfo } from '@pedix-workspace/shared-stock';
import { CouponValidationErrorCode, Establishment, PricingError } from '@pedix-workspace/utils';

export function isEstablishmentClosedError(
  error: unknown,
): error is { details: { workingDays: Establishment['workingDays'] } } {
  if (typeof error !== 'object') {
    return false;
  }
  return (error as any)?.details?.workingDays;
}

export function isOrderNotFoundError(error: unknown): error is Error {
  if (typeof error !== 'object') {
    return false;
  }
  return (error as any)?.code === 'functions/not-found';
}

export function isOrderStockError(
  error: unknown,
): error is { details: { stockErrors: StockInfo[] } } {
  if (typeof error !== 'object') {
    return false;
  }
  return (error as any)?.details?.stockErrors;
}

export function isOrderPricingError(
  error: unknown,
): error is { details: { pricingErrors: PricingError[] } } {
  if (typeof error !== 'object') {
    return false;
  }
  return (error as any)?.details?.pricingErrors;
}

export function isCouponValidationError(
  error: unknown,
): error is { details: { couponValidationErrorCode: CouponValidationErrorCode } } {
  if (typeof error !== 'object') {
    return false;
  }
  return (error as any)?.details?.couponValidationErrorCode;
}
